module.exports = __webpack_public_path__ + "media/images/creator/home/about-01-046337ea62e25646d81c821760a7fbb2.png";